import * as apcoaAPI from '@debbie/cortex/dist/api/bespoke/apcoa.js';
import { feeKey, parkingLotKey, useFee, } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useEffect, useState } from 'react';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import Button from '../../Button.js';
import CopyToClipboard from '../../CopyToClipboard.js';
import { Edit } from '../../Icons/index.js';
import Input from '../../Input.js';
import Modal from '../../Modal.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import Table from '../../Table.js';
const Cancellations = (props) => {
    const { caseVoucher } = props;
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const [policy, setPolicy] = useState('');
    const [loading, setLoading] = useState(false);
    const [policyModalOpen, setPolicyModalOpen] = useState(false);
    console.log(fee);
    useEffect(() => {
        if (fee?.entitledForCancellation) {
            setPolicy(fee.entitledForCancellation);
        }
    }, [fee?.entitledForCancellation]);
    const savePolicy = async () => {
        setLoading(true);
        try {
            if (!fee?.parkingLotCode) {
                throw new Error('No parking lot code');
            }
            await apcoaAPI.patchParkingLot(fee.parkingLotCode, {
                policy,
            });
            q.invalidate([
                parkingLotKey(fee.parkingLotCode),
                feeKey(caseVoucher.referenceId),
            ]);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setPolicyModalOpen(false);
        setLoading(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(feeLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            h.hasData(feeLoadable) && fee ? (React.createElement(React.Fragment, null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", null, "Pladsejer"),
                        React.createElement("td", null, fee.parkingLotOwnerName)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Pladsnummer"),
                        React.createElement("td", null,
                            React.createElement(CopyToClipboard, { text: fee.parkingLotCode }, fee.parkingLotCode))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Adresse"),
                        React.createElement("td", null,
                            fee.parkingLotAddress,
                            React.createElement("br", null),
                            fee.parkingLotAddress2 ? (React.createElement(React.Fragment, null,
                                fee.parkingLotAddress2,
                                React.createElement("br", null))) : null)),
                    React.createElement("tr", { onClick: () => setPolicyModalOpen(!policyModalOpen), style: { cursor: 'pointer' } },
                        React.createElement("td", null, "Annulleringsberettiget"),
                        React.createElement("td", null,
                            fee.entitledForCancellation,
                            ' ',
                            React.createElement(Edit, { style: { float: 'right', cursor: 'pointer' } }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Annulleringer"),
                        React.createElement("td", null,
                            fee.noOfCancellations,
                            " / ",
                            fee.maxNoOfCancellations || '-')),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Antal Ejer14 annuleringer"),
                        React.createElement("td", null, fee.noOfOwner14Cancellations))))) : (!h.isError(feeLoadable) && (React.createElement(React.Fragment, null,
                React.createElement(PlaceholderLoader, { width: "200px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "120px" }),
                React.createElement("br", null),
                React.createElement(PlaceholderLoader, { width: "140px" })))),
            policyModalOpen && (React.createElement(Modal, { header: 'Policy', onToggle: () => setPolicyModalOpen(!policyModalOpen), maxWidth: "500px" },
                React.createElement(Input, { placeholder: "Policy", onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            savePolicy();
                        }
                    }, value: policy, onChange: (e) => setPolicy(e.target.value), autofocus: true }),
                React.createElement("br", null),
                React.createElement(Button, { loading: loading, onClick: () => {
                        savePolicy();
                    } }, "Gem"))))));
};
export default Cancellations;
//# sourceMappingURL=Cancellations.js.map